import { PropsWithChildren } from "react";
import styles from "./FormCard.module.css";

const FormCard: React.FC<PropsWithChildren> = ({ children }) => (
  <div className={styles.root}>
    <div className={styles.inner}>{children}</div>
  </div>
);

export default FormCard;
